import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import HeadsetInterface from 'resources/headsets/headset-interface';
import { disconnectFromPlantronicsHub, pollEvents, signalIncomingCall, signalOutgoingCall, signalAnsweringCall, signalEndingCall, signalHoldingCall, signalResumingCall, signalMutingCall, signalUnmutingCall } from 'resources/headsets/plantronics/plantronics-service';
import { hashCodeFromString } from 'flow/utils';
var PlantronicsHeadset = /*#__PURE__*/function (_HeadsetInterface) {
  function PlantronicsHeadset() {
    _classCallCheck(this, PlantronicsHeadset);
    return _callSuper(this, PlantronicsHeadset, arguments);
  }
  _inherits(PlantronicsHeadset, _HeadsetInterface);
  return _createClass(PlantronicsHeadset, [{
    key: "attachCallbacks",
    value: function attachCallbacks(callbacks) {
      pollEvents(callbacks(this.id));
      return this;
    }
  }, {
    key: "onDisconnectImpl",
    value: function onDisconnectImpl() {
      var _this = this;
      disconnectFromPlantronicsHub()["catch"](function (e) {
        return _superPropGet(PlantronicsHeadset, "logError", _this, 3)(['Failed to disconnect headset', e]);
      });
    }
  }, {
    key: "incomingCallImpl",
    value: function incomingCallImpl(callId) {
      var _this2 = this;
      signalIncomingCall(hashCodeFromString(callId))["catch"](function (e) {
        return _superPropGet(PlantronicsHeadset, "logError", _this2, 3)(['Error when signaling incoming call', e]);
      });
    }
  }, {
    key: "outgoingCallImpl",
    value: function outgoingCallImpl(callId) {
      var _this3 = this;
      signalOutgoingCall(hashCodeFromString(callId))["catch"](function (e) {
        return _superPropGet(PlantronicsHeadset, "logError", _this3, 3)(['Error when signaling outgoing call', e]);
      });
    }
  }, {
    key: "confirmCallImpl",
    value: function confirmCallImpl(callId) {
      var _this4 = this;
      signalAnsweringCall(hashCodeFromString(callId))["catch"](function (e) {
        return _superPropGet(PlantronicsHeadset, "logError", _this4, 3)(['Error when signaling answering call', e]);
      });
    }
  }, {
    key: "endCallImpl",
    value: function endCallImpl(callId) {
      var _this5 = this;
      signalEndingCall(hashCodeFromString(callId))["catch"](function (e) {
        return _superPropGet(PlantronicsHeadset, "logError", _this5, 3)(['Error when signaling end call', e]);
      });
    }
  }, {
    key: "holdCallImpl",
    value: function holdCallImpl(callId) {
      var _this6 = this;
      signalHoldingCall(hashCodeFromString(callId))["catch"](function (e) {
        return _superPropGet(PlantronicsHeadset, "logError", _this6, 3)(['Error when signaling hold call', e]);
      });
    }
  }, {
    key: "resumeCallImpl",
    value: function resumeCallImpl(callId) {
      var _this7 = this;
      signalResumingCall(hashCodeFromString(callId))["catch"](function (e) {
        return _superPropGet(PlantronicsHeadset, "logError", _this7, 3)(['Error when signaling resume call', e]);
      });
    }
  }, {
    key: "muteCallImpl",
    value: function muteCallImpl() {
      var _this8 = this;
      signalMutingCall()["catch"](function (e) {
        return _superPropGet(PlantronicsHeadset, "logError", _this8, 3)(['Error when signaling mute call', e]);
      });
    }
  }, {
    key: "unmuteCallImpl",
    value: function unmuteCallImpl() {
      var _this9 = this;
      signalUnmutingCall()["catch"](function (e) {
        return _superPropGet(PlantronicsHeadset, "logError", _this9, 3)(['Error when signaling unmute call', e]);
      });
    }
  }]);
}(HeadsetInterface);
export { PlantronicsHeadset as default };